/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MonitResolutionRequestScope = {
    Mute: 'mute',
    Remove: 'remove',
    Ignore: 'ignore'
} as const;
export type MonitResolutionRequestScope = typeof MonitResolutionRequestScope[keyof typeof MonitResolutionRequestScope];


export function MonitResolutionRequestScopeFromJSON(json: any): MonitResolutionRequestScope {
    return MonitResolutionRequestScopeFromJSONTyped(json, false);
}

export function MonitResolutionRequestScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitResolutionRequestScope {
    return json as MonitResolutionRequestScope;
}

export function MonitResolutionRequestScopeToJSON(value?: MonitResolutionRequestScope | null): any {
    return value as any;
}

